import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_9 = { class: "col-lg-8 fv-row" }
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "row mb-6" }
const _hoisted_13 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_14 = { class: "col-lg-8 fv-row" }
const _hoisted_15 = { class: "fv-plugins-message-container" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = { class: "row mb-6" }
const _hoisted_18 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_19 = { class: "col-lg-8 fv-row" }
const _hoisted_20 = ["label"]
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "fv-plugins-message-container" }
const _hoisted_23 = { class: "fv-help-block" }
const _hoisted_24 = { class: "row mb-6" }
const _hoisted_25 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_26 = { class: "col-lg-8 fv-row" }
const _hoisted_27 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_28 = { class: "row mb-6" }
const _hoisted_29 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_30 = { class: "col-lg-8 fv-row" }
const _hoisted_31 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_32 = { class: "row mb-6" }
const _hoisted_33 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_34 = { class: "col-lg-8 fv-row" }
const _hoisted_35 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_36 = { class: "row mb-6" }
const _hoisted_37 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_38 = { class: "col-lg-8 fv-row" }
const _hoisted_39 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_40 = {
  key: 0,
  class: "row mb-6"
}
const _hoisted_41 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_42 = { class: "col-lg-8 fv-row" }
const _hoisted_43 = { class: "d-flex flex-wrap gap-4" }
const _hoisted_44 = ["onUpdate:modelValue"]
const _hoisted_45 = { class: "form-check-label fw-bold ms-2" }
const _hoisted_46 = { class: "row mb-6" }
const _hoisted_47 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_48 = { class: "col-lg-8 fv-row" }
const _hoisted_49 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_50 = {
  key: 1,
  class: "row mb-6"
}
const _hoisted_51 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_52 = { class: "col-lg-8 fv-row" }
const _hoisted_53 = { class: "d-flex flex-wrap gap-4" }
const _hoisted_54 = ["onUpdate:modelValue"]
const _hoisted_55 = { class: "form-check-label fw-bold ms-2" }
const _hoisted_56 = {
  key: 2,
  class: "row mb-6"
}
const _hoisted_57 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_58 = { class: "col-lg-8 fv-row" }
const _hoisted_59 = { class: "d-flex flex-wrap gap-4" }
const _hoisted_60 = ["value"]
const _hoisted_61 = { class: "form-check-label fw-bold ms-2" }
const _hoisted_62 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_63 = {
  key: 0,
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_64 = { class: "indicator-label" }
const _hoisted_65 = { class: "indicator-progress" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.can('read', 'assets'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('updateArea')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Form, {
            class: "form",
            onSubmit: _ctx.onSubmitUpdate,
            "validation-schema": _ctx.areaSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.translate('arabicName')), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "titleAr",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('areaNameArLang'),
                      modelValue: _ctx.area.titleAr,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.area.titleAr) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_ErrorMessage, { name: "titleAr" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.translate('englishName')), 1),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "titleEn",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('areaNameEnLang'),
                      modelValue: _ctx.area.titleEn,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.area.titleEn) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_ErrorMessage, { name: "titleEn" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.translate('Government')), 1),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "governorateId",
                      class: "form-select form-select-solid form-select-lg text-capitalize",
                      modelValue: _ctx.area.governorateId,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.area.governorateId) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", {
                          disabled: "",
                          selected: "",
                          value: "0",
                          label: _ctx.translate('selectGovernment')
                        }, null, 8, _hoisted_20),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.govs, (gov) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: gov.id,
                            value: gov.id
                          }, _toDisplayString(gov.titleAr), 9, _hoisted_21))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_ErrorMessage, { name: "type" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.translate('isRegisteredTrades')) + ": ", 1),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("label", _hoisted_27, [
                      _createVNode(_component_Field, {
                        class: "form-check-input",
                        name: "isRegisteredTrades",
                        type: "checkbox",
                        value: true,
                        checked: "checked",
                        modelValue: _ctx.area.isRegisteredTrades,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.area.isRegisteredTrades) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.translate('isAd')) + ": ", 1),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("label", _hoisted_31, [
                      _createVNode(_component_Field, {
                        class: "form-check-input",
                        name: "isAd",
                        type: "checkbox",
                        value: true,
                        checked: "checked",
                        modelValue: _ctx.area.isAd,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.area.isAd) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.translate('isAuction')) + ": ", 1),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("label", _hoisted_35, [
                      _createVNode(_component_Field, {
                        class: "form-check-input",
                        name: "isAuction",
                        type: "checkbox",
                        value: true,
                        checked: "checked",
                        modelValue: _ctx.area.isAuction,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.area.isAuction) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.translate('isPriceIndex')) + ": ", 1),
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("label", _hoisted_39, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.isPriceIndex) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.isPriceIndex]
                      ])
                    ])
                  ])
                ]),
                (_ctx.isPriceIndex)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                      _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.translate('viewTypes')) + ": ", 1),
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.viewTypesByIndexType[_ctx.IndicesType.PRICE_INDEX.id], (vt) => {
                            return (_openBlock(), _createElementBlock("label", {
                              key: vt.id,
                              class: "form-check form-check-custom form-check-solid me-4"
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                class: "form-check-input",
                                type: "checkbox",
                                "onUpdate:modelValue": ($event: any) => ((_ctx.viewAvailabilities[vt.id]) = $event)
                              }, null, 8, _hoisted_44), [
                                [_vModelCheckbox, _ctx.viewAvailabilities[vt.id]]
                              ]),
                              _createElementVNode("span", _hoisted_45, _toDisplayString(vt.title_ar), 1)
                            ]))
                          }), 128))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.translate('isVolumeIndex')) + ": ", 1),
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("label", _hoisted_49, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.isVolumeIndex) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.isVolumeIndex]
                      ])
                    ])
                  ])
                ]),
                (_ctx.isVolumeIndex)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                      _createElementVNode("label", _hoisted_51, _toDisplayString(_ctx.translate('viewTypes')) + ": ", 1),
                      _createElementVNode("div", _hoisted_52, [
                        _createElementVNode("div", _hoisted_53, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.viewTypesByIndexType[
                    _ctx.IndicesType.VOLUME_INDEX.id
                  ], (vt) => {
                            return (_openBlock(), _createElementBlock("label", {
                              key: vt.id,
                              class: "form-check form-check-custom form-check-solid me-4"
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                class: "form-check-input",
                                type: "checkbox",
                                "onUpdate:modelValue": ($event: any) => ((_ctx.viewAvailabilities[vt.id]) = $event)
                              }, null, 8, _hoisted_54), [
                                [_vModelCheckbox, _ctx.viewAvailabilities[vt.id]]
                              ]),
                              _createElementVNode("span", _hoisted_55, _toDisplayString(vt.title_ar), 1)
                            ]))
                          }), 128))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isPriceIndex || _ctx.isVolumeIndex)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                      _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.translate('supportedCategories')) + ": ", 1),
                      _createElementVNode("div", _hoisted_58, [
                        _createElementVNode("div", _hoisted_59, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.indicesPropertyCategories, (category) => {
                            return (_openBlock(), _createElementBlock("label", {
                              key: category.id,
                              class: "form-check form-check-custom form-check-solid me-4"
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                class: "form-check-input",
                                type: "checkbox",
                                value: category.id,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.supportedCategories) = $event))
                              }, null, 8, _hoisted_60), [
                                [_vModelCheckbox, _ctx.supportedCategories]
                              ]),
                              _createElementVNode("span", _hoisted_61, _toDisplayString(category.titleAr), 1)
                            ]))
                          }), 128))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("button", {
                  type: "reset",
                  class: "btn btn-white btn-active-light-primary me-2",
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                }, _toDisplayString(_ctx.translate('discard')), 1),
                (_ctx.can('update', 'assets'))
                  ? (_openBlock(), _createElementBlock("button", _hoisted_63, [
                      _createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.translate('saveChanges')), 1),
                      _createElementVNode("span", _hoisted_65, [
                        _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                        _hoisted_66
                      ])
                    ], 512))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ]))
    : _createCommentVNode("", true)
}